import {
  IconButton as NIconButton,
  type IconButtonProps as NIconButtonProps,
} from '@natera/material/lib/button'
import React, { forwardRef } from 'react'
import { useNavigate } from 'react-router'
import { cn } from '~/shared/lib/cn'
import './icon-button.scss'

interface IconButtonProps extends Omit<NIconButtonProps, 'children'> {
  to?: string
  size?: 'small' | 'medium' | 'large'
  container?: 'small' | 'medium'
  children?: React.ReactNode
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, className, size, container, to, onClick, ...rest }, ref) => {
    const navigate = useNavigate()

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (to && (e.metaKey || e.ctrlKey || e.button === 1)) {
        window.open(to, '_blank')
      } else if (to) {
        navigate(to)
      } else {
        onClick?.(e)
      }
    }

    return (
      <NIconButton
        {...rest}
        ref={ref}
        onClick={handleClick}
        className={cn(
          'c-icon-button',
          {
            'c-icon-button--small': size === 'small',
            'c-icon-button--medium': size === 'medium',
            'c-icon-button--large': size === 'large',
            'c-icon-button--container-small': container === 'small',
            'c-icon-button--container-medium': container === 'medium',
          },
          className,
        )}
      >
        {/* @ts-expect-error for some reason common IconButtonProps expects string as children, but we want to use React.ReactNode */}
        {children}
      </NIconButton>
    )
  },
)
